import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { CopyBox } from 'src/common';
import { useGetSsoEntityIdAndReplyUrl } from 'src/models/company/Security/hooks';

export const SsoMetaInfo: FC = () => {
  const { t } = useTranslation();
  const { data: idAndUrlData } = useGetSsoEntityIdAndReplyUrl();

  const entityId = useMemo(() => idAndUrlData?.getSsoEntityIdAndReplyUrl.entityId || '', [idAndUrlData]);
  const replyUrl = useMemo(() => idAndUrlData?.getSsoEntityIdAndReplyUrl.replyUrl || '', [idAndUrlData]);

  return (
    <ul className={styles.info}>
      <li className={styles.infoItem}>
        <span className={styles.infoLabel}>{t('Security.entityId')}</span>
        <CopyBox value={entityId} />
      </li>
      <li className={styles.infoItem}>
        <span className={styles.infoLabel}>{t('Security.replyUrl')}</span>
        <CopyBox value={replyUrl} />
      </li>
    </ul>
  );
};

export default SsoMetaInfo;
